module.exports = __webpack_public_path__ + "img/holiday_page.3c1e8c6d.jpg";